import { useState } from "react";
import { Loader2 } from "lucide-react";
import { api, errMsg } from "@/lib/api";

export const inputCls = "w-full rounded-xl border border-[var(--line)] bg-[var(--ink-2)] px-4 py-3 text-[var(--bone)] placeholder:text-zinc-500 focus:border-[var(--cash)] focus:outline-none";
export const btnCls = "flex items-center justify-center gap-2 rounded-full bg-[var(--cash)] px-6 py-3 font-mono text-xs font-bold uppercase tracking-[0.2em] text-[var(--ink)] transition-transform hover:scale-[1.02] disabled:opacity-60";

export const LoginCard = ({ onLogin }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError("");
    try {
      const { data } = await api.post("/auth/login", { email, password });
      onLogin(data);
    } catch (err) {
      setError(errMsg(err));
    } finally { setBusy(false); }
  };
  return (
    <div className="guilloche flex min-h-screen items-center justify-center px-4">
      <form onSubmit={submit} data-testid="admin-login-form" className="w-full max-w-sm rounded-[28px] border border-[var(--line)] bg-[rgba(16,16,16,0.85)] p-8 backdrop-blur-xl">
        <img src="/mae-logo-ink.webp" alt="MAE" className="mx-auto h-24 w-24 rounded-full" />
        <h1 className="mt-6 text-center font-display text-3xl uppercase">Admin login</h1>
        <div className="mt-8 space-y-3">
          <input data-testid="admin-email-input" type="email" required className={inputCls} placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} />
          <input data-testid="admin-password-input" type="password" required className={inputCls} placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} />
        </div>
        {error && <p data-testid="admin-login-error" className="mt-3 text-sm text-red-400">{error}</p>}
        <button data-testid="admin-login-submit" disabled={busy} className={`${btnCls} mt-6 w-full`}>{busy && <Loader2 size={16} className="animate-spin" />} Log in</button>
      </form>
    </div>
  );
};
